import { render, staticRenderFns } from "./ConsolidatedRemittanceTab.vue?vue&type=template&id=8d3d6858&"
import script from "./ConsolidatedRemittanceTab.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedRemittanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports